<template>
  <div>
    <el-select
      v-model="typeSelected"
      :clearable="isClearable"
      :size="inputSize"
      placeholder="Seleccione una Semana"
      @change="OnInvoiceWeekSelected"
    >
      <el-option
        v-for="item in typeOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "WeekSelector",
  props: {
    initialValue: {
      type: String,
      default: "",
      required: false
    },
    inputSize: {
      type: String,
      default: "mini",
      required: false
    },
    isClearable: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      typeOptions: [
        {
          value: "S1",
          label: "Semana 1"
        },
        {
          value: "S2",
          label: "Semana 2"
        },
        {
          value: "S3",
          label: "Semana 3"
        },
        {
          value: "S4",
          label: "Semana 4"
        },
        {
          value: "S5",
          label: "Semana 5"
        }
      ]
      // typeSelected: this.initialValue
    };
  },
  computed: {
    typeSelected() {
      return this.initialValue;
    }
  },
  mounted() {},

  methods: {
    OnInvoiceWeekSelected(week) {
      // console.log("OnInvoiceTypeSelected 1: ", type);

      this.$emit("OnInvoiceWeekSelected", week);
    }
  }
};
</script>

<style scoped></style>
